/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import Accordion from 'accordions';

/*------------------------------------------------------------------
Accordion Content
------------------------------------------------------------------*/

const getState = (data, index) => {
  let state = null;

  switch (data) {
    case 'first-open':
      state = (index == 0);
      break;
    case 'all-open':
      state = 1;
      break;
    default:
      state = 0;
      break;
  }

  return state;
}


[...document.querySelectorAll('.js-default-accordion')].forEach((block) => {
  const items = block.querySelectorAll('.js-default-accordion__item');
  const data = block.getAttribute('data-state');

  const Controller = new Accordion(block, {
    multiple: (data == 'all-open'),
  });

  for (let i = 0; i < items.length; i++) {
    // Save the item
    const item = items[i];

    Controller.add(item, {
      active: getState(data, i),
      trigger: item.querySelector('.js-default-accordion__trigger'),
      target: item.querySelector('.js-default-accordion__target'),
    });
  }
});
